import { Card, ComposedText, ComposedTextScoreCard } from "@ptsd/uikit";
import { View } from "tamagui";

import type { ComposedTextProps } from "./utils";

export const HomeComposedText: React.FC<ComposedTextProps> = ({
  title,
  markdown,
  scoreCard,
}) => {
  const { score, scoreState, dynamicsState, description, dynamics } =
    scoreCard ?? {};
  if (!markdown) return null;
  return (
    <Card
      data-id="home-composed-text-card"
      shadow={"md"}
      rounded={"lg"}
      padding={"$5"}
    >
      <ComposedText.Container
        variant="borderless"
        shadow="none"
        justifyContent="space-between"
        backgroundColor={"$warm-snow-500"}
        data-id="home-composed-text-container"
      >
        <ComposedText.TextContainer data-id="home-composed-text-wrapper">
          <ComposedText.Title data-id="home-composed-text-title">
            {title}
          </ComposedText.Title>
          <ComposedText.RenderMd
            data-id="home-composed-text-markdown"
            md={markdown ?? ""}
          />
        </ComposedText.TextContainer>
        <ComposedText.ScoreContainer
          data-id="home-composed-text-score-container"
          maxWidth={312}
        >
          <ComposedTextScoreCard.Container
            data-id="home-composed-text-score-card"
            maxWidth={312}
            justifyContent="center"
            flex={1}
          >
            <View gap={"$6"}>
              <View justifyContent="center" alignItems="center" gap="$3">
                <ComposedTextScoreCard.ScoreWrapper
                  data-id="home-composed-text-score-wrapper"
                  state="success"
                >
                  <ComposedTextScoreCard.Score
                    data-id="home-composed-text-score"
                    state={scoreState}
                  >
                    {score}
                  </ComposedTextScoreCard.Score>
                </ComposedTextScoreCard.ScoreWrapper>
                <ComposedTextScoreCard.Dynamics
                  state={dynamicsState}
                  description={description ?? ""}
                  text={dynamics ?? ""}
                />
              </View>
            </View>
          </ComposedTextScoreCard.Container>
        </ComposedText.ScoreContainer>
      </ComposedText.Container>
    </Card>
  );
};
